import { render } from "./Restaurants.vue?vue&type=template&id=1175b81f&ts=true"
import script from "./Restaurants.vue?vue&type=script&lang=ts"
export * from "./Restaurants.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Work\\Picado\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__